import { ChevronDown } from 'lucide-react'

import { Button } from '../ui/button'
import { Popover, PopoverContent, PopoverTrigger } from '../ui/popover'
import { Separator } from '../ui/separator'
import { CompanyDisplay } from './company-display'
import { CompanyList } from './company-list'
import { CompanySearch } from './company-search'
import { useCompanySelection } from './use-company-selection'

export function CompanySelection() {
  const {
    hasSingleCompany,
    company,
    filteredCompanies,
    isOpen,
    searchValue,
    handleOpenChange,
    handleSearchChange,
    handleClearSearch,
    handleSelectCompany,
  } = useCompanySelection()

  if (hasSingleCompany) {
    return (
      <div className="min-w-52 px-2">
        <CompanyDisplay company={company} />
      </div>
    )
  }

  return (
    <Popover open={isOpen} onOpenChange={handleOpenChange}>
      <PopoverTrigger asChild>
        <Button variant="ghost" className="h-10 min-w-52 justify-between px-2">
          <CompanyDisplay company={company} />
          <ChevronDown />
        </Button>
      </PopoverTrigger>

      <PopoverContent
        align="start"
        className="w-72 p-0"
        onOpenAutoFocus={(event) => event.preventDefault()}
      >
        <CompanySearch
          autoFocus
          value={searchValue}
          onChange={handleSearchChange}
          onClear={handleClearSearch}
        />

        <Separator />

        <CompanyList
          companies={filteredCompanies}
          onSelect={handleSelectCompany}
        />
      </PopoverContent>
    </Popover>
  )
}
